<template>

  <div class="food-card bg-white">
    <b-row>
      <b-col lg="6">
        <img class="w-100  shop-food-img" :src="image" :alt="alt"/>
      </b-col>
      <b-col lg="6" class="d-flex flex-column align-items-start justify-content-center text-right ">
        <slot name="p-1"></slot>
      </b-col>
      <b-col lg="12" class="my-3">
        <slot name="p-2"></slot>
      </b-col>
    </b-row>
  </div>

</template>

<script>
export default {
  name: "C304",
  props: {
    image: {
      default: 'https://picsum.photos/1280/720'
    },
    alt: {
      default: 'mix it web'
    }
  },
}
</script>

<style scoped>
.food-card {
  border-radius: 25px;
  padding: 5px;
  height: max-content;
}

.food-card .card-body {
  padding: 5px;
  margin: 0;
}

.q-link {
  height: 25px;
  line-height: 10px;
  background-color: var(--primary);
  color: var(--light);
}

.shop-food-img {
  border-radius: 25px;
  height: 150px;
  object-fit: cover;
}

.add-to-shopping-card {
  background-color: var(--primary);
  border: none;
}

.food-comment-btn {
  background-color: var(--secondary);
  color: var(--light);
}


.control-btn {
  text-decoration: none;
  padding: 0 3px 0;
  margin: 0px;
  color: white;
  font-weight: bold;
  width: max-content;
  height: max-content;
  border-radius: 100%;
}

.add-to-cart {
  border-radius: 15px;
}

.add-to-cart:hover {
  color: white !important;
}


</style>